import { render } from "./BookListEmptyState.vue?vue&type=template&id=584abbc5&scoped=true"
const script = {}

import "./BookListEmptyState.vue?vue&type=style&index=0&id=584abbc5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584abbc5"]])

export default __exports__